import React from 'react';
import PersonalInfoForm from './PersonalInfoForm';
import Agreement from '../Agreement';
import Banking from '../Banking';
import ThankYou from '../ThankYou';
import Wordings from '../../config/stringTable';
import { LanguageConsumer } from '../../config/LanguageContext';

const PERSONAL_STEP = 0;
const CONSENT_STEP = 1;
const BANKING_STEP = 2;
const THANK_YOU_STEP = 3;

const renderStep = (
  step,
  onNextStep,
  loanReferenceId,
  props,
  validationData,
  formData,
  onFieldChange,
  setValidation,
  onAgreementAccepted,
) => {
  if (step === PERSONAL_STEP) {
    return (
      <PersonalInfoForm
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        loanReferenceId={loanReferenceId}
        onNext={onNextStep}
        validations={validationData}
        formData={formData}
        onChange={onFieldChange}
        onFormValidated={setValidation}
      />
    );
  }
  if (step === CONSENT_STEP) {
    return (
      <Agreement
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        guestUser
        onAgreementAccepted={onAgreementAccepted}
      />
    );
  }
  if (step === BANKING_STEP) {
    return (
      <Banking
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        onNextStep={onNextStep}
        isAllowedAccess
        guestUser
        hideSkipButton
        preventRedirectToSocial
      />
    );
  }
  if (step === THANK_YOU_STEP) {
    return (
      <ThankYou />
    );
  }
  return null;
};

const renderError = () => (
  <LanguageConsumer>
    {({ language }) => (
      <>
        <h3>{ Wordings[language]['Unable to process your request'] }</h3>
        <p>
          {
            // eslint-disable-next-line max-len
            Wordings[language]['An error occurred while processing your application. Please contact your lender for more information.']
          }
        </p>
      </>
    )}
  </LanguageConsumer>
);

export default function DealerIBVLandingPageView(props) {
  return (
    <div>
      {
    props.errorState
      ? renderError()
      : renderStep(
        props.step,
        props.nextStep,
        props.loanReferenceId,
        props,
        props.validations,
        props.formData,
        props.onFieldChange,
        props.setValidation,
        props.onAgreementAccepted,
      )
  }
    </div>
  );
}
